import { render, staticRenderFns } from "./VuesticSimpleSelect.vue?vue&type=template&id=5953c769"
import script from "./VuesticSimpleSelect.vue?vue&type=script&lang=js"
export * from "./VuesticSimpleSelect.vue?vue&type=script&lang=js"
import style0 from "./VuesticSimpleSelect.vue?vue&type=style&index=0&id=5953c769&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pagsmile/front-end/pagsmile-dashboard/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5953c769')) {
      api.createRecord('5953c769', component.options)
    } else {
      api.reload('5953c769', component.options)
    }
    module.hot.accept("./VuesticSimpleSelect.vue?vue&type=template&id=5953c769", function () {
      api.rerender('5953c769', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vuestic-theme/vuestic-components/vuestic-simple-select/VuesticSimpleSelect.vue"
export default component.exports